(function () {
    document.addEventListener("DOMContentLoaded", (event) => {
        const searchLocationModules = document.querySelectorAll(".map-single-location");

        Array.prototype.forEach.call(searchLocationModules, (el, i) => {
            const currentEl = el;
            const location = {
                lat: parseFloat(currentEl.getAttribute("data-locationLat")),
                lng: parseFloat(currentEl.getAttribute("data-locationLng")),
                zoom: parseInt(currentEl.getAttribute("data-locationZoom"))
            };
            singleMap.initMap(currentEl, location);
        });
    });

    const singleMap = {
        data: {
            map: null
        },
        initMap: async function (el, location) {
            const _this = this;

            // Request libraries when needed, not in the script tag.
            const { Map } = await google.maps.importLibrary("maps");
            // Short namespaces can be used.
            _this.data.map = new Map(el, {
                center: { lat: location.lat, lng: location.lng },
                zoom: location.zoom,
            });

            _this.setMarker(_this.data.map, location);
        },
        setMarker: function (map, location) {
            const marker = new google.maps.Marker({
                position: { lat: location.lat, lng: location.lng },
                map: map
            });
        }
    };
})();